import React, { useRef } from 'react';

import { renderToStaticMarkup } from 'react-dom/server';
import { divIcon } from 'leaflet';
import { Marker, Popup, Tooltip } from 'react-leaflet';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { regular, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import Row from "../../Grid/Row";
import Column from "../../Grid/Column";
import Button from "../../Button/Button";
import Modal from "../../Modal/Modal";
import ExternalLink from "../../Link/ExternalLink";
import useModal from "../../Modal/useModal";
import EditCutForm from 'components/Form/EditCutForm';
import FlexWraper from 'components/Grid/FlexWrapper';
import { cutStepDetails } from './cutStepDetails';

function MapMarker({
    coordinates,
    address,
    street,
    weight,
    orderDate,
    cut,
    refreshCuts,
    setLoading
}) {
    const {isShowing, toggleModal} = useModal();

    let latestStep = '';
    let iconMarkup = '';

    // function isMoreThanNDaysAgo(orderDate, days, lessThan = false) {
    //     const transformedDate = new Date(orderDate);
    //     //                   days  hours min  sec  ms
    //     const thirtyDaysInMs = days * 24 * 60 * 60 * 1000;
    //     const timestampThirtyDaysAgo = new Date().getTime() - thirtyDaysInMs;

    //     if (lessThan) {
    //         return timestampThirtyDaysAgo < transformedDate;
    //     }

    //     return timestampThirtyDaysAgo > transformedDate;
    // }

    if (cut.steps.length === 0){
        const step = cutStepDetails[0];
        latestStep = step.label;
        iconMarkup = renderToStaticMarkup(<FontAwesomeIcon style={{color: step.color}} icon={solid('map-marker-alt')} />);
    } else if (cut.steps.length === 1) {
        const step = cutStepDetails[1];
        latestStep = step.label;
        iconMarkup = renderToStaticMarkup(<FontAwesomeIcon style={{color: step.color}} icon={solid('map-marker-alt')} />);
    } else if (cut.steps.length === 2) {
        if (cut.product.name === 'Concrete') {
            const step = cutStepDetails[3];
            latestStep = step.label;
            iconMarkup = renderToStaticMarkup(<FontAwesomeIcon style={{color: step.color}} icon={solid('map-marker-alt')}/>);
        } else {
            const step = cutStepDetails[2];
            latestStep = step.label;
            iconMarkup = renderToStaticMarkup(<FontAwesomeIcon style={{color: step.color}} icon={solid('map-marker-alt')}/>);
        }
    }
    
    if (cut.product.name === "Asphalt" && cut.steps.length === 3) {
        const step = cutStepDetails[4];
        latestStep = step.label;
        iconMarkup = renderToStaticMarkup(<FontAwesomeIcon style={{color: step.color}} icon={solid('map-marker-alt')} />);

    }

    const customMarkerIcon = divIcon({
            html: iconMarkup,
            iconSize: [35, 35],
    });

    const formattedDate = new Date(orderDate).toLocaleDateString('en-us', {  timeZone: 'UTC', year:"numeric", month:"long", day:"numeric"});

    // Scroll to success message when form submitted
    const modalRef = useRef(null);

    const scrollTop = () => {
        modalRef.current.scrollIntoView();
    }

    return (
      <Marker icon={customMarkerIcon} position={coordinates}>
          <Popup minWidth={250}>
            <h5 style={{margin:"8px 0"}}>{latestStep} - {cut.product.name}</h5>
            <Row>
                <Column width={1/1}>
                    <p style={{margin:"8px 0"}}><FontAwesomeIcon icon={regular('weight-hanging')} style={{marginRight:"7px"}} />{weight}</p>
                </Column>
                <Column width={1/1}>
                    <p style={{margin:"8px 0"}}><FontAwesomeIcon icon={regular('calendar')} style={{marginRight:"7px"}} />{formattedDate}</p>
                </Column>
                <Column width={1/1}>
                    <p style={{margin:"8px 0"}}><FontAwesomeIcon icon={regular('user')} style={{marginRight:"7px"}} />{cut?.project?.client?.name}</p>
                </Column>
            </Row>

            {address && (
                <p style={{margin:"8px 0 12px 0"}}><FontAwesomeIcon icon={regular('location-dot')} style={{marginRight:"7px"}} />{address} {street}</p>
            )}
                <FlexWraper>
                {address && (                
                    <ExternalLink target="_blank" to={'https://www.google.com/maps/dir/?api=1&destination=' + coordinates.join(',')}>
                        Directions
                    </ExternalLink>
                )}
                    <Button
                        size={'sm'}
                        onClick={toggleModal}
                    >
                        Edit
                    </Button>
                    <Modal isShowing={isShowing} hide={toggleModal} title="Edit Cut" modalRef={modalRef}>
                        <EditCutForm cut={cut} refreshCuts={refreshCuts} latestStep={latestStep} formattedDate={formattedDate} setLoading={setLoading} toggleModal={toggleModal} scrollTop={scrollTop} />
                    </Modal>
                </FlexWraper>
          </Popup>
          {/* <Tooltip direction="bottom" offset={[0, 20]} opacity={1} permanent>
              { weight }
          </Tooltip> */}
      </Marker>
  );
}

export default MapMarker;
